import openPopup from '../popup.js';

const firmwareTitle = document.querySelector('#popup-firmware .firmware-title')
const firmwareContent = document.querySelector('#popup-firmware .firmware-content')
let firmwareLink = document.querySelector('#popup-firmware .ui-btn')
const btnOpenFirmwarePopup = document.querySelectorAll('.btn_firmware')


const firmwareBasicLink = 'https://iql.finance/firmwares/Whatsminer-m2x-m3x-m5x-28_normal_bixbitsite_AMS_bixbit_site_1.4.8_1psu.bin';
const firmware2PSULink = 'https://iql.finance/firmwares/Whatsminer-m2x-m3x-m5x-28_normal_bixbitsite_AMS_bixbit_site_1.4.8_2psu.bin';
const H3plata = 'https://iql.finance/firmwares/H3 SD card Program-20210121.zip';
const H6plata = 'https://iql.finance/firmwares/H6 SD Card Program-20210121.zip';
const H616plata = 'https://iql.finance/firmwares/H616 SD card program-20220729.zip';
const H6osplata = 'https://iql.finance/firmwares/H6os SD Card Program-20220422.zip';
const firmwareTool  = 'https://iql.finance/firmwares/WhatsMinerTool-8.1.38.zip';

const firmwareData = [
   {
      id: 1,
      title: 'Прошивка для ASIC WhatsMiner серии M2X',
      file: 'https://iql.finance/firmwares/Whatsminer-m2x-m3x-m5x-28_normal_bixbitsite_AMS_bixbit_site_1.4.8_1psu.bin',
      content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">Кастомная прошивка для Whatsminer серии M5x предназначена для всех моделей с дополнительным питанием, что позволяет разгонять устройства выше 50%.</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">Дополнительная информация</h5>
               <p class="content-text">Поддержка дополнительного блока питания и увеличение производительности выше 50%</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">Инструкция по установке</h5>

               <div class="important-item">
                  <h6 class="item-title">Важно!</h6>
                  <p class="content-text">Разгон устройства при плохом охлаждении может вывести устройства из строя.</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">Скачайте <a href=${firmwareBasicLink} target="_blank">прошивку BiXBiT для M2x</a>. Используйте <a href=${firmwareTool} target="_blank">WhatsMinerTool</a> для установки.</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">Если прошивка не устанавливается через WhatsMinerTool, необходимо прошить асик через SD-карту. Для этого:</p>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">Проверьте версию вашей контрольной платы (для M2x используются контрольные платы <strong>H3, H6, H6os</strong>).</li>
                     <li class="content-list-item">Скачайте с официального сайта MicroBT утилиту для плат <a href=${H3plata} target="_blank">H3</a>, <a href=${H6plata} target="_blank">H6</a> или <a href=${H6osplata} target="_blank">H6os</a>, позволяющую откатить ваше оборудование к сервисной прошивке.</li>
                     <li class="content-list-item">
                        <p class="content-text">Подготовьте ASIC к установке с SD-карты. Подробный процесс показан на видео ниже:</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/9QC2ueL1E2g?si=z_uc8avthp_sqadI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">После установки, откройте веб-панель асика и зайдите во вкладку <strong>Configuration>Miner Configuration>Overclock</strong>. Здесь доступны настройки конфигурации вашего асика.</p>
                        <p class="content-text">В данном разделе есть опция <strong>Immersion Cooling</strong>, которую необходимо выбрать при погружении асика в жидкость. При возникновении ошибок, связанных с кулером блока питания, требуется прошить БП, используя опцию в прошивке: <strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmwareBasicLink} target="_blank" download>
            <span>Скачать</span> <img src="assets/img/icons/download.svg"></i>
         </a>
      `
   },

   {
      id: 2,
      title: 'Прошивка для ASIC WhatsMiner серии M3x',
      file: 'https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_1psu.bin',
      content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">Кастомная прошивка Whatsminer M31s от BiXBiT подходит для моделей M30, M31, M32 и обеспечивает разгон вплоть до ~130Th/s в условиях наилучшей конфигурации. Понятный интерфейс, множество полезных инструментов и программная совместимость с иммерсионным типом охлаждения.</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">Дополнительная информация</h5>
               <p class="content-text">Прошивка открывает максимальные возможности блоков питания, вольтажа чипов и их тактовой частоты. При использовании устройства с тремя платами производительность возрастает на ~10%, а при использовании варианта с двумя платами — на 40%. Имеется функция автоматической прошивки блока для работы с иммерсионным охлаждением. Вознаграждение разработчика — 2,8%.</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">Инструкция по установке</h5>

               <div class="important-item">
                     <h6 class="item-title">Важно!</h6>
                     <p class="content-text">Разгон устройства при плохом охлаждении может вывести устройства из строя.</p>
               </div>

               <div class="content-wrap">
                     <p class="content-text">Скачайте <a href=${firmwareBasicLink} target="_blank">прошивку BiXBiT для M3x</a>. Используйте <a href=${firmwareTool} target="_blank">WhatsMinerTool</a> для установки.</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">Если прошивка не устанавливается через WhatsMinerTool, необходимо прошить асик через SD-карту. Для этого:</p>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">Проверьте версию вашей контрольной платы (для M3x используются контрольные платы <strong>H3, H6, H6os, H616</strong>).</li>
                     <li class="content-list-item">Скачайте с официального сайта MicroBT утилиту для плат <a href=${H3plata} target="_blank">H3</a>, <a href=${H6plata} target="_blank">H6</a>, <a href=${H6osplata} target="_blank">H6os</a> или <a href=${H616plata} target="_blank">H616</a>, позволяющую откатить ваше оборудование к сервисной прошивке.</li>
                     <li class="content-list-item">
                        <p class="content-text">Подготовьте ASIC к установке с SD-карты. Подробный процесс показан на видео ниже:</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=EaORD8gkUPDce8zE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">После установки, откройте веб-панель асика и зайдите во вкладку <strong>Configuration>Miner Configuration>Overclock</strong>. Здесь доступны настройки конфигурации вашего асика.</p>
                        <p class="content-text">В данном разделе есть опция <strong>Immersion Cooling</strong>, которую необходимо выбрать при погружении асика в жидкость. При возникновении ошибок, связанных с кулером блока питания, требуется прошить БП, используя опцию в прошивке: <strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmwareBasicLink} target="_blank" download>
            <span>Скачать</span> <img src="assets/img/icons/download.svg"></i>
         </a>
      `
   },

   {
      id: 3,
      title: 'Прошивка для ASIC WhatsMiner серии M5x',
      file: 'https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_1psu.bin',
      content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">Альтернативная прошивка для Whatsminer серии M5x предназначена для всех моделей и позволяет разогнать ASIC в зависимости от конфигурации.</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">Дополнительная информация</h5>
               <p class="content-text">Убирает заводские ограничения по PSU, напряжению и чиповым частотам.</p>
               <p class="content-text">Позволяет нарастить мощность до 10% на трёх платах и до 40% на двух.</p>
               <p class="content-text">Комиссия разработчика – 2,8%.</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">Инструкция по установке</h5>

               <div class="important-item">
                  <h6 class="item-title">Важно!</h6>
                  <p class="content-text">Разгон устройства при плохом охлаждении может вывести устройства из строя.</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">Скачайте <a href=${firmwareBasicLink} target="_blank">прошивку BiXBiT для M5x</a>. Используйте <a href=${firmwareTool} target="_blank">WhatsMinerTool</a> для установки.</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">Если прошивка не устанавливается через WhatsMinerTool, необходимо прошить асик через SD-карту. Для этого:</p>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">Проверьте версию вашей контрольной платы (для M3x используются контрольные платы <strong>H6os, H616</strong>).</li>
                     <li class="content-list-item">Скачайте с официального сайта MicroBT утилиту для плат <a href=${H6osplata} target="_blank">H6os</a> или <a href=${H616plata} target="_blank">H616</a>, позволяющую откатить ваше оборудование к сервисной прошивке.</li>
                     <li class="content-list-item">
                        <p class="content-text">Подготовьте ASIC к установке с SD-карты. Подробный процесс показан на видео ниже:</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">После установки, откройте веб-панель асика и зайдите во вкладку <strong>Configuration>Miner Configuration>Overclock</strong>. Здесь доступны настройки конфигурации вашего асика.</p>
                        <p class="content-text">В данном разделе есть опция <strong>Immersion Cooling</strong>, которую необходимо выбрать при погружении асика в жидкость. При возникновении ошибок, связанных с кулером блока питания, требуется прошить БП, используя опцию в прошивке: <strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmwareBasicLink} target="_blank" download>
            <span>Скачать</span> <img src="assets/img/icons/download.svg"></i>
         </a>
      `
   },

   {
      id: 4,
      title: 'Прошивка для ASIC Whatsminer серии M2x с поддержкой дополнительного питания',
      file: 'https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_2psu.bin',
      content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">Кастомная прошивка для Whatsminer серии M2x предназначена для разгона ASIC моделей M20, M21 с дополнительным питанием, что позволяет разгонять устройства выше 50%.</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">Дополнительная информация</h5>
               <p class="content-text">Убирает заводские ограничения по PSU, напряжению и чиповым частотам.</p>
               <p class="content-text">Позволяет нарастить мощность до 10% на трёх платах и до 40% на двух.</p>
               <p class="content-text">Комиссия разработчика – 2,8%.</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">Инструкция по установке</h5>

               <div class="important-item">
                  <h6 class="item-title">Важно!</h6>
                  <p class="content-text">Разгон устройства при плохом охлаждении может вывести устройства из строя.</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">Скачайте <a href=${firmware2PSULink} target="_blank">прошивку BiXBiT_Add PSU для M2x</a>. Используйте <a href=${firmwareTool} target="_blank">WhatsMinerTool</a> для установки.</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">Если прошивка не устанавливается через WhatsMinerTool, необходимо прошить асик через SD-карту, как показано на видео ниже:</p>
                  <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=LcVkHBfwpsfZ4CLd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">
                        <p class="content-text">Подключите дополнительный блок питания к ASIC. Подробный процесс показан на видео ниже:</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">После установки, откройте веб-панель асика и зайдите во вкладку <strong>Configuration>Miner Configuration>Overclock</strong>. Здесь доступны настройки конфигурации вашего асика.</p>
                        <p class="content-text">В данном разделе есть опция <strong>Immersion Cooling</strong>, которую необходимо выбрать при погружении асика в жидкость. При возникновении ошибок, связанных с кулером блока питания, требуется прошить БП, используя опцию в прошивке: <strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmware2PSULink} target="_blank" download>
            <span>Скачать</span> <img src="assets/img/icons/download.svg"></i>
         </a>
      `
   },

   {
      id: 5,
      title: 'Прошивка для ASIC Whatsminer серии M3x с поддержкой дополнительного питания',
      file: 'https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_2psu.bin',
      content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">Кастомная прошивка для Whatsminer серии M3x предназначена для разгона ASIC моделей M30, M31 и M32 с дополнительным питанием, что позволяет разгонять устройства выше 50%.</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">Дополнительная информация</h5>
               <p class="content-text">Разгон устройств с помощью изменений настроек частоты, напряжения и потребления.</p>
               <p class="content-text">Поддержка дополнительного блока питания и увеличение производительности выше 50%.</p>
               <p class="content-text">Поддержка иммерсионного режима охлаждения.</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">Инструкция по установке</h5>

               <div class="important-item">
                  <h6 class="item-title">Важно!</h6>
                  <p class="content-text">Разгон устройства при плохом охлаждении может вывести устройства из строя.</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">Скачайте <a href=${firmware2PSULink} target="_blank">прошивку BiXBiT_Add PSU для M3x</a>. Используйте <a href=${firmwareTool} target="_blank">WhatsMinerTool</a> для установки.</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">Если прошивка не устанавливается через WhatsMinerTool, необходимо прошить асик через SD-карту, как показано на видео ниже:</p>
                  <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=LcVkHBfwpsfZ4CLd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">
                        <p class="content-text">Подключите дополнительный блок питания к ASIC. Подробный процесс показан на видео ниже:</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">После установки, откройте веб-панель асика и зайдите во вкладку <strong>Configuration &gt; Miner Configuration &gt; Overclock</strong>. Здесь доступны настройки конфигурации вашего асика.</p>
                        <p class="content-text">В данном разделе есть опция <strong>Immersion Cooling</strong>, которую необходимо выбрать при погружении асика в жидкость. При возникновении ошибок, связанных с кулером блока питания, требуется прошить БП, используя опцию в прошивке: <strong>Configuration &gt; Miner Configuration &gt; PSU Firmware &gt; Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmware2PSULink} target="_blank" download>
            <span>Скачать</span> <img src="assets/img/icons/download.svg"></i>
         </a>
      `
   },

   {
      id: 6,
      title: 'Прошивка для ASIC Whatsminer серии M5x с поддержкой дополнительного питания',
      file: 'https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_2psu.bin',
      content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">Кастомная прошивка для Whatsminer серии M5x предназначена для всех моделей с дополнительным питанием, что позволяет разгонять устройства выше 50%.</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">Дополнительная информация</h5>
               <p class="content-text">Разгон устройств с помощью изменений настроек частоты, напряжения и потребления.</p>
               <p class="content-text">Поддержка дополнительного блока питания и увеличение производительности выше 50%.</p>
               <p class="content-text">Поддержка иммерсионного режима охлаждения.</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">Инструкция по установке</h5>

               <div class="important-item">
                  <h6 class="item-title">Важно!</h6>
                  <p class="content-text">Разгон устройства при плохом охлаждении может вывести устройства из строя.</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">Скачайте <a href=${firmware2PSULink} target="_blank">прошивку BiXBiT_Add PSU для M5x</a>. Используйте <a href=${firmwareTool} target="_blank">WhatsMinerTool</a> для установки.</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">Если прошивка не устанавливается через WhatsMinerTool, необходимо прошить асик через SD-карту, как показано на видео ниже:</p>
                  <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=LcVkHBfwpsfZ4CLd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">
                        <p class="content-text">Подключите дополнительный блок питания к ASIC. Подробный процесс показан на видео ниже:</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">После установки, откройте веб-панель асика и зайдите во вкладку <strong>Configuration &gt; Miner Configuration &gt; Overclock</strong>. Здесь доступны настройки конфигурации вашего асика.</p>
                        <p class="content-text">В данном разделе есть опция <strong>Immersion Cooling</strong>, которую необходимо выбрать при погружении асика в жидкость. При возникновении ошибок, связанных с кулером блока питания, требуется прошить БП, используя опцию в прошивке: <strong>Configuration &gt; Miner Configuration &gt; PSU Firmware &gt; Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmware2PSULink} target="_blank" download>
            <span>Скачать</span> <img src="assets/img/icons/download.svg"></i>
         </a>
      `
   },
 
]

btnOpenFirmwarePopup.forEach(item => {
   item.addEventListener('click', function () {
      let currentBtn = this.getAttribute('data-id')
      firmwareTitle.innerHTML = ''
      firmwareContent.innerHTML = ''

      let currentDataFirmware = firmwareData.find(item => item.id == currentBtn)

      if (currentDataFirmware) {
         let {title, content, file} = currentDataFirmware

         firmwareTitle.insertAdjacentHTML('afterbegin', title)
         firmwareContent.insertAdjacentHTML('afterbegin', content)
      }
   })
})

new openPopup({
   selector: '#popup-firmware',
   elOpen: '.btn_firmware',
   elClose: '#popup-firmware .ui-close',
   overlay: '#popup-firmware .popup-overlay',
   hasVideo: true
})